module.exports = __webpack_public_path__ + "img/box-4.18fc0ad9.png";